import { Appl } from "../../../../core/Appl";
import NotificationListViewModel from "./list/NotificationListViewModel";
import { NotificationService } from "./NotificationService";

export default class NotificationModule {
    public static init(): void {
        Appl.Services.add('INotificationService', NotificationService);
        Appl.Services.add('NotificationListViewModel', NotificationListViewModel);
    }
}